const BASE_BLOB_URL = "https://testauthenticator.blob.core.windows.net/astr-assets";

export const BLOB_IMAGES = {
  saketa: `${BASE_BLOB_URL}/saketa.png`,
  close: `${BASE_BLOB_URL}/close.png`,
  searchIcon: `${BASE_BLOB_URL}/search-icon.png`,
  success: `${BASE_BLOB_URL}/success.gif`,
  dummyImage: `${BASE_BLOB_URL}/dummy-image.png`,
  spinnerGif: `${BASE_BLOB_URL}/saketa-loading.gif`,
  userDashboardIcon: `${BASE_BLOB_URL}/3Userdashboard.png`,
  licenseIcon: `${BASE_BLOB_URL}/wrkspaceicon.png`,
  migratorIcon: `${BASE_BLOB_URL}/migrator.png`,
  slack: `${BASE_BLOB_URL}/slack.png`,
  teams: `${BASE_BLOB_URL}/teams.png`,
  eclipse: `${BASE_BLOB_URL}/eclipse.png`,
  failed: `${BASE_BLOB_URL}/failed.gif`,
  failedpic: `${BASE_BLOB_URL}/failedpic.png`,
  microsoftlogo: `${BASE_BLOB_URL}/microsoftlogo.png`,
  arrow_1: `${BASE_BLOB_URL}/arrow-1.png`,
  plus: `${BASE_BLOB_URL}/adduser.png`,
  slackDisable: `${BASE_BLOB_URL}/slackdisable.png`,
  arrowLogo: `${BASE_BLOB_URL}/arrow.png`,
  teamsDisable: `${BASE_BLOB_URL}/teamsdisable.png`,
  downarrow: `${BASE_BLOB_URL}/downarrow.png`,
  filter_icon: `${BASE_BLOB_URL}/filter-icon.png`,
  successIcon:`${BASE_BLOB_URL}/success.png`
};


